export const AVERAGE_SHIFTS_PER_MONTH = 4.4;
const RETURN_RATE = 0.05;

const weeksPerMonth = 4.345;

export const calculateInvestmentInterestAfterAWeek = (baseInvestment: number) => {
  const weeksPerYear = 52;
  const weeklyRate = Math.pow(1 + RETURN_RATE, 1 / weeksPerYear) - 1;
  return baseInvestment * (1 + weeklyRate) - baseInvestment;
};

export const savingsAfter = (baseSavings: number, savingsPerShift: number, weeks: number) => {
  let weeksSimulated = 0;
  let currentSavings = baseSavings;
  let totalInvestmentInterest = 0;
  while (weeksSimulated < weeks) {
    weeksSimulated++;
    const investmentInterestThisWeek = calculateInvestmentInterestAfterAWeek(
      currentSavings + savingsPerShift
    );
    currentSavings += savingsPerShift + investmentInterestThisWeek;
    totalInvestmentInterest += investmentInterestThisWeek;
  }
  return { currentSavings, totalInvestmentInterest };
};

/**
 * Generic binary search function to find the minimum value that satisfies a condition
 * @param low - The lower bound of the search range
 * @param high - The upper bound of the search range
 * @param valueIsCorrectOrTooHigh - Function that returns true if the value satisfies the condition
 * @returns The minimum value that satisfies the condition, or upperBound if none found
 */
function binarySearch(
  low: number,
  high: number,
  valueIsCorrectOrTooHigh: (value: number) => boolean
): number {
  let lowerBound = low;
  let upperBound = high;
  let result = upperBound;

  while (lowerBound <= upperBound) {
    const mid = Math.floor((lowerBound + upperBound) / 2);

    if (valueIsCorrectOrTooHigh(mid)) {
      result = mid;
      upperBound = mid - 1; // Try to find a smaller value
    } else {
      lowerBound = mid + 1; // Need a larger value
    }
  }

  return result;
}

export const weeksUntilGoal = (
  baseSavings: number,
  savingsPerShift: number,
  goalAmount: number
) => {
  if (savingsPerShift <= 0) {
    return 0;
  }

  if (baseSavings >= goalAmount) {
    return 0;
  }

  return binarySearch(0, 10000, (weeks) => {
    const { currentSavings } = savingsAfter(baseSavings, savingsPerShift, weeks);
    return currentSavings >= goalAmount;
  });
};

export const shiftsUntilGoal = (
  baseSavings: number,
  savingsPerShift: number,
  goalAmount: number
): number => {
  const weeksNeeded = weeksUntilGoal(baseSavings, savingsPerShift, goalAmount);

  const shiftsPerWeek = AVERAGE_SHIFTS_PER_MONTH / weeksPerMonth;
  const totalShifts = weeksNeeded * shiftsPerWeek;

  return Math.ceil(totalShifts);
};
